import api from '@pray/shared/utils/api';

// DELETE /warmup-campaigns/:id/audiences/:id responds 204 No Content. The
// server rejects removal when the campaign is `done`, and enforces a min-1
// guard for `active` / `disabled`. The UI only surfaces this affordance on
// `draft`, but defense-in-depth lives on the server.
export async function removeWarmupAudience({
  artistId,
  warmupCampaignId,
  audienceId,
}: {
  artistId: string;
  warmupCampaignId: string;
  audienceId: string;
}): Promise<void> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!warmupCampaignId) throw new Error('Warmup campaign ID is required');
  if (!audienceId) throw new Error('Audience ID is required');

  const url = `/web/studio/artists/${artistId}/warmup-campaigns/${warmupCampaignId}/audiences/${audienceId}`;
  await api.executeDeleteRequest<void>(url);
}
